export default {
  pfizer: {
    /////PAGE REGISTER/////
    'register_title': 'Formulaire d\'inscription',
    /////PAGE LOGIN/////
    'login_title': 'Plateforme partenaires',
    /////PAGE HOME/////
    'home_new': 'Enregistrer mes demandes',
    'home_title_new': 'Enregistrer les demandes',
    'home_add_file': 'Ajouter une autre demande',
    /////NAVBAR/////
    'navbar_demandes': 'Demandes',
    /////LIST/////
    'list_title': 'Suivi de mes demandes',
  },
  henkel: {
    /////PAGE REGISTER/////
    'register_title': 'Formulaire d\'inscription',
    /////PAGE LOGIN/////
    'login_title': 'Plateforme Points de vente',
    /////PAGE HOME/////
    'home_new': 'Enregistrer les sorties caisses',
    'home_title_new': 'Enregistrer les sorties caisses',
    'home_add_file': 'Ajouter un autre fichier',
    /////NAVBAR/////
    'navbar_demandes': 'Opérations',
    /////LIST/////
    'list_title': 'Suivi de mes opérations',
  },
  roge_cavailles: {
    /////PAGE REGISTER/////
    'register_title': 'Formulaire d\'inscription',
    /////PAGE LOGIN/////
    'login_title': 'Plateforme partenaires',
    /////PAGE HOME/////
    'home_new': 'Je participe',
    'home_title_new': 'J\'enregistre mes téléchargements',
    'home_add_file': 'Ajouter une autre demande',
    /////NAVBAR/////
    'navbar_demandes': 'Mes téléchargements',
    /////LIST/////
    'list_title': 'Suivi de mes téléchargements',
  },
  abinbev: {
    /////PAGE REGISTER/////
    'register_title': 'Formulaire d\'inscription',
    /////PAGE LOGIN/////
    'login_title': 'Plateforme partenaires',
    /////PAGE HOME/////
    'home_new': 'Je participe',
    'home_title_new': 'J\'enregistre mes téléchargements',
    'home_add_file': 'Ajouter une autre demande',
    /////NAVBAR/////
    'navbar_demandes': 'Mes téléchargements',
    /////LIST/////
    'list_title': 'Suivi de mes téléchargements',
  },
  oreal: {
      /////PAGE REGISTER/////
      'register_title': 'Formulaire d\'inscription',
      /////PAGE LOGIN/////
      'login_title': 'Plateforme partenaires',
      /////PAGE HOME/////
      'home_new': 'Je participe',
      'home_title_new': 'J\'enregistre mes participations',
      'home_add_file': 'Ajouter une autre demande',
      /////NAVBAR/////
      'navbar_demandes': 'Mes téléchargements',
      /////LIST/////
      'list_title': 'Suivi de mes téléchargements',
    },
  essity: {
    /////PAGE REGISTER/////
    'register_title': 'Formulaire d\'inscription',
    /////PAGE LOGIN/////
    'login_title': 'Plateforme partenaires',
    /////PAGE HOME/////
    'home_new': 'Je participe',
    'home_title_new': 'J\'enregistre mes participations',
    'home_add_file': 'Ajouter une autre demande',
    /////NAVBAR/////
    'navbar_demandes': 'Mes téléchargements',
    /////LIST/////
    'list_title': 'Suivi de mes téléchargements',
  }
}



// WEBPACK FOOTER //
// ./src/translation/translate.jsx